import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import * as _ from 'lodash';

import { AppComponentGenericComponent } from '../../custom/app-component-generic/app-component-generic.component';
import { DataService } from '../../../services/data.service';

import { CanalePagamento } from '../../../models/canale-pagamento';
import { OrderByPipe } from '../../../pipes/order-by.pipe';

@Component({
  selector: 'app-canali-pagamento',
  templateUrl: './canali-pagamento.component.html',
  styleUrls: ['./canali-pagamento.component.css']
})
export class CanaliPagamentoComponent extends AppComponentGenericComponent implements OnInit {
	rows: any;
	editable: any = {};
	comune_id = -1;
	enteCanale: string = '';
	coordinateCanale: string = '';
	canaliPagamento: CanalePagamento[] = [];
	canaliPagamentoSync: Subscription;

	constructor(protected dataService: DataService) {
		super(dataService, 'canali-pagamento');
	}

	ngOnInit() {
		this.canaliPagamentoSync = this.dataService.canaliPagamento$.subscribe(
			canaliPagamento => {
				this.canaliPagamento = canaliPagamento;
				this.reset();
			});
	}

	reset(){
		this.comune_id = -1;
		this.enteCanale = '';
		this.coordinateCanale = '';
		if(this.canaliPagamento){
			for (let row of this.canaliPagamento){
				this.editable[row.id] = null;
			}
		}
	}

	aggiungiCanalePagamento() {
		let newCanale: CanalePagamento;
		if (this.enteCanale != '') {
			newCanale = new CanalePagamento();
			newCanale.comune_id = this.comune_id;
			newCanale.ente = this.enteCanale;
			newCanale.coordinate = this.coordinateCanale;

			this.dataService.insert("canali_pagamento", newCanale, true, (error,res) => {
				if (error) {
					this.dataService.openMessage('INSERIMENTO CANALE DI PAGAMENTO','si è verificato un errore');
				}
			});
		}
	}

	modificaCanalePagamento(row: any) {
		this.editable[row.id] = _.cloneDeep(row);
	}

	discard(row: any){
		this.editable[row.id] = null;
	}

	commit(row: any){
		let localFilters = [];
		localFilters.push({ type: "=", key: "id", value: row.id });

		this.dataService.update("canali_pagamento", localFilters, this.editable[row.id], true, (error,res) => {
			if(res){
				this.editable[row.id] = null;
			}
		});
	}

	eliminaCanalePagamento(row: any) {
		let localFilters = [];
		localFilters.push({ type: "=", key: "id", value: row.id });
		let index = this.canaliPagamento.indexOf(row);

		if(index !== -1){
			this.dataService.delete("canali_pagamento", localFilters, true, (error,res) => {
				if (error) {
					//this.dataService.openMessage('ELIMINAZIONE CANALE DI PAGAMENTO','si è verificato un errore');
				}
			});
		}
	}

	ngOnDestroy() {
		this.canaliPagamentoSync.unsubscribe();
	}
}
